import { render, staticRenderFns } from "./SelectedServices.vue?vue&type=template&id=3426f427&scoped=true"
import script from "./SelectedServices.vue?vue&type=script&lang=js"
export * from "./SelectedServices.vue?vue&type=script&lang=js"
import style0 from "./SelectedServices.vue?vue&type=style&index=0&id=3426f427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3426f427",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default})
